import { ValidatedForm } from "components";
import { Tooltip } from "components/common/tooltip";
import { Icon } from "semantic-ui-react";
import { type CommonComponentProps } from "features/Library/Common/props";
import styles from "./Checkbox.module.scss";

type Props = Omit<CommonComponentProps, "propertyNamePrefix" | "onBlur"> & {
  propertyName: string;
  isChecked: boolean;
  label: string;
  tooltip: string;
};

export const Checkbox = (props: Props) => {
  const { validatedFieldProps, propertyName, disabled, onChanged, isChecked, label, tooltip } = props;

  return (
    <div className={styles.container}>
      <ValidatedForm.CheckboxField
        {...validatedFieldProps}
        toggle
        label={label}
        value={isChecked}
        propertyName={propertyName}
        disabled={disabled}
        handleChange={onChanged}
      />
      <Tooltip
        target={<Icon className="info circle" />}
        content={tooltip}
        position="top center"
        styles={{ width: "20rem" }}
        hideOnScroll
        showAlways
      />
    </div>
  );
};
